import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

interface ContestFiltersProps {
  onFilterChange: (filter: string) => void;
  onSearchChange: (search: string) => void;
}

const filters = [
  { id: 'all', label: 'Tous' },
  { id: 'active', label: 'En cours' },
  { id: 'upcoming', label: 'À venir' },
  { id: 'ended', label: 'Terminés' },
];

export const ContestFilters: React.FC<ContestFiltersProps> = ({
  onFilterChange,
  onSearchChange,
}) => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  const handleFilterClick = (filterId: string) => {
    setActiveFilter(filterId);
    onFilterChange(filterId);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQuery(value);
    onSearchChange(value);
  };

  return (
    <div className="flex flex-col gap-4">
      {/* Barre de recherche */}
      <div className="relative w-full">
        <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
          <Search className="h-5 w-5 text-gray-400" />
        </div>
        <Input
          type="text"
          className="w-full pl-10 pr-4 py-2 bg-white/5 border border-white/10 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-yellow-400/50"
          placeholder="Rechercher un concours..."
          value={searchQuery}
          onChange={handleSearchChange}
        />
      </div>

      {/* Filtres */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {filters.map((filter) => (
          <button
            key={filter.id}
            onClick={() => handleFilterClick(filter.id)}
            className={cn(
              'px-4 py-2 rounded-xl bg-white/5 border border-white/10 text-white hover:bg-white/20 text-sm sm:text-base',
              activeFilter === filter.id
                ? 'bg-yellow-400/10 border-yellow-400/30'
                : ''
            )}
          >
            {filter.label}
          </button>
        ))}
      </div>
    </div>
  );
};
